import { useMutation } from '../utils/useQuery';
import { type PasswordDto, ProxyControllerService, type ProxyRequestDto } from '../openapi';

export const useExecuteScanApi = () => {
  return useMutation(async (values: ProxyRequestDto) => {
    return ProxyControllerService.proxyRequest(values);
  });
};

export const useValidatorApiAccessToken = (validatorName: string) => {
  return useMutation(async (values: PasswordDto) => {
    return ProxyControllerService.getValidatorApiAccessToken(validatorName, values);
  });
};
